module.exports = __webpack_public_path__ + "img/logo.a808baff.png";